<template>
  <span v-html="template.function(row, $root)"/>
</template>

<script>
export default {
  name: 'TemplateFunction',
  props: {
    row: { type: Object, required: true },
    col: { type: Object, required: true },
    template: { type: Object, required: true }
  }
}
</script>
